module.exports = __webpack_public_path__ + "static/media/azwuncreative-project.1bbfd878.png";